import React from "react";
import logo from "../../assets/img/loader.png";
import { Button, Card, CardHeader, CardBody, CardFooter, Form, Input, InputGroupAddon, InputGroupText, InputGroup, Container, Col, Row } from "reactstrap";
import { forgotPassword } from "../../services/userService";
import { usePageLoading } from "hooks/usePageLoading";

const Recuperar = (props) => {
  const doneLoading = usePageLoading(props);
  const [data, setData] = React.useState({
    email: "",
  });
  const [sent, setSent] = React.useState(false);
  const [firstFocus, setFirstFocus] = React.useState(false);

  React.useEffect(() => {
    document.body.classList.add("login-page");
    // document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    doneLoading(); // no hay datos que traer
    return function cleanup() {
      document.body.classList.remove("login-page");
      // document.body.classList.remove("sidebar-collapse");
    };
  }, []);

  const doRecuperar = async (event) => {
    event.preventDefault();
    try {
      await forgotPassword(data);
      setSent(true);
    } catch {}
  };

  const goHome = () => {
    window.location = "/login";
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      doRecuperar(event);
    }
  };

  const handleChange = ({ currentTarget: input }) => {
    const newData = { ...data };
    newData[input.name] = input.value;
    setData(newData);
  };

  return (
    <>
      <div className="page-header header-filter">
        <div
          className="page-header-image"
          style={{
            backgroundImage: "url(" + require("assets/img/landing-background.png") + ")",
          }}
        ></div>
        <div className="content">
          <Container>
            <Row>
              <Col className="ml-auto mr-auto" md="5">
                <Card className="card-login card-plain">
                  <Form action="" className="form" method="">
                    <CardHeader className="text-center">
                      <div>
                        <img alt="..." src={logo} style={{ height: "150px", width: "150px" }}></img>
                      </div>
                    </CardHeader>
                    {!sent && (
                      <>
                        <CardBody>
                          <Row>
                            <Col md="12" className="mb-2">
                              <h4>Recuperar contraseña</h4>
                              <p>Ingrese su e-mail para recibir las instrucciones para recuperar su contraseña</p>
                            </Col>
                          </Row>
                          <InputGroup className={"no-border input-lg" + (firstFocus ? " input-group-focus" : "")}>
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText>
                                {/* <i className="now-ui-icons users_circle-08"></i> */}
                                <i className="fas fa-user"></i>
                              </InputGroupText>
                            </InputGroupAddon>
                            <Input
                              autoFocus
                              id="email"
                              name="email"
                              placeholder="Ingrese su e-mail"
                              type="text"
                              onChange={handleChange}
                              onFocus={() => setFirstFocus(true)}
                              onBlur={() => setFirstFocus(false)}
                              onKeyPress={handleKeyPress}
                              value={data.username}
                            ></Input>
                          </InputGroup>
                        </CardBody>
                        <CardFooter className="text-center">
                          <Button block className="btn-round btn-arhock" onClick={(event) => doRecuperar(event)} size="lg">
                            Recuperar Contraseña
                          </Button>
                        </CardFooter>
                      </>
                    )}
                    {sent && (
                      <>
                        <CardBody>
                          <Row>
                            <Col md="12" className="mb-2">
                              <h4>Link Enviado</h4>
                              <p>Enviamos un mail a tu casilla de correo, con las instrucciones para recuperar tu contraseña</p>
                            </Col>
                          </Row>
                        </CardBody>
                        <CardFooter className="text-center">
                          <h6>
                            <a className="link footer-link clickable" onClick={goHome}>
                              Ingresar
                            </a>
                          </h6>
                        </CardFooter>
                      </>
                    )}
                  </Form>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </>
  );
};

export default Recuperar;
